import { alineaciones } from '@/helpers/analisis-plantilla-fantasy-helper';

const useFormationName = (formation) => {
    const realFormation = alineaciones.find((f) => f.value === formation);

    if (realFormation) {
        return realFormation?.label;
    }

    return formation;
};

export default useFormationName;
